export const DISCOUNTED_PARAM = 'discounted';
